import { EBuildingHeatingType } from 'shared/types/filters/advanced/buildingHeatingType';

export const mapBuildingHeatingTypeLabel = {
  [EBuildingHeatingType.Autonomous]: 'Автономное',
  [EBuildingHeatingType.Central]: 'Центральное',
  [EBuildingHeatingType.Without]: 'Нет',
};
